import React from 'react';
import {
    actionClass,
    actionDisabled,
    formatAction,
    getCustomMessageClass,
    handleMessageActions,
    styles
} from '../utils/messageUtils';

export function RequestActions({requestObject, requestOptions, customType, requestId, isMobile, isByMe}) {
    if (!requestOptions?.value) return null;
    if (!requestObject && customType !== 'ai_assistant') return null;

    return (
        <div
            className={`${getCustomMessageClass(customType)} ${isByMe ? "outgoing" : "incoming"} sendbird-text-message-item-body`}
            style={styles.actionsContainer(isMobile)}
        >
            {requestOptions.value.map((option) => (
                <button
                    id={`${getCustomMessageClass(customType)}-action-${requestId}-${formatAction(option)}`}
                    key={option}
                    className={actionClass(formatAction(option))}
                    onClick={() => handleMessageActions(customType, formatAction(option), requestId)}
                    disabled={
                        customType !== 'ai_assistant' &&
                        actionDisabled(customType, formatAction(option), requestObject)
                    }
                    style={{marginTop: 0.5 + 'rem', marginBottom: 0.5 + 'rem'}}
                >
                    {option}
                </button>
            ))}
        </div>
    );
}
